var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHolidaysMenuItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.742,
    height: 18.742,
    viewBox: "0 0 18.742 18.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44639054"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3223",
    "data-name": "Rectangle 3223",
    width: 18.742,
    height: 18.742,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98437",
    "data-name": "Group 98437",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10073",
    "data-name": "Group 10073",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-44639054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13068",
    "data-name": "Path 13068",
    d: "M14.814,1.559h-.78V.78a.78.78,0,0,0-1.559,0v.78H6.237V.78a.78.78,0,1,0-1.559,0v.78H3.9A3.9,3.9,0,0,0,0,5.458v9.356a3.9,3.9,0,0,0,3.9,3.9H14.814a3.9,3.9,0,0,0,3.9-3.9V5.458a3.9,3.9,0,0,0-3.9-3.9M1.559,5.458A2.339,2.339,0,0,1,3.9,3.119H14.814a2.339,2.339,0,0,1,2.339,2.339v.78H1.559Zm13.255,11.7H3.9a2.339,2.339,0,0,1-2.339-2.339V7.8H17.153v7.017a2.339,2.339,0,0,1-2.339,2.339",
    transform: "translate(0.03 0.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13069",
    "data-name": "Path 13069",
    d: "M225.17,288a1.17,1.17,0,1,1-1.17,1.17,1.17,1.17,0,0,1,1.17-1.17",
    transform: "translate(-215.784 -277.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13070",
    "data-name": "Path 13070",
    d: "M118.5,288a1.17,1.17,0,1,1-1.17,1.17A1.17,1.17,0,0,1,118.5,288",
    transform: "translate(-113.015 -277.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13071",
    "data-name": "Path 13071",
    d: "M331.836,288a1.17,1.17,0,1,1-1.169,1.17,1.17,1.17,0,0,1,1.169-1.17",
    transform: "translate(-318.552 -277.445)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidaysMenuItem);
export default __webpack_public_path__ + "static/media/holidays-menu-item.8b06e55d9b039eb1b1ca3a1125b03d23.svg";
export { ForwardRef as ReactComponent };